type CountDaysExcludingWeekdaysParms = {
  startDate: Date;
  endDate: Date;
  excludedDays: number[];
};

export function countDaysExcludingWeekdays({ startDate, endDate, excludedDays }: CountDaysExcludingWeekdaysParms) {
  const start = startDate;
  const end = endDate;

  let count = 0;
  const dayInMS = 24 * 60 * 60 * 1000;

  for (let d = start; d <= end; d = new Date(d.getTime() + dayInMS)) {
    const dayOfWeek = d.getDay();
    if (!excludedDays.includes(dayOfWeek)) {
      count++;
    }
  }

  return count;
}
